function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import { GALLERY_CONSTS } from 'pro-gallery';
import { utils } from '../../common/utils/utils';
import CustomButton from '../buttons/CustomButton.js';
import Title from './Title.js';
import Description from './Description.js';
import lineHeightFixer from './LineHeightFixer.js';
import designConsts from '../../common/constants/designConsts.js';

var Texts = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Texts, _React$Component);

  function Texts(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.debouncedTryFixLineHeight = utils.debounce(_this.tryFixLineHeight.bind(_assertThisInitialized(_this)), 500).bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = Texts.prototype;

  _proto.getElementClassNames = function getElementClassNames() {
    var _this$props = this.props,
        showShare = _this$props.showShare,
        styleParams = _this$props.styleParams,
        isNarrow = _this$props.isNarrow;
    var classNames = ['info-element-text'];

    if (showShare) {
      classNames.push('hidden');
    }

    if (styleParams.showArrows) {
      classNames.push('padded-horizontal');
    }

    if (isNarrow) {
      classNames.push('narrow-item');
    }

    return classNames.join(' ');
  };

  _proto.allowAnyAction = function allowAnyAction() {
    var styleParams = this.props.styleParams;
    return styleParams.loveButton || styleParams.allowSocial || styleParams.allowDownload;
  };

  _proto.getElementStyle = function getElementStyle() {
    var _this$props2 = this.props,
        styleParams = _this$props2.styleParams,
        style = _this$props2.style;
    var textsDisplayOnHover = !styleParams.isSlideshow && !styleParams.isSlider && !styleParams.hasThumbnails && GALLERY_CONSTS.hasHoverPlacement(styleParams.titlePlacement) && styleParams.hoveringBehaviour !== GALLERY_CONSTS.infoBehaviourOnHover.NEVER_SHOW;
    var isCentered = style.justifyContent === 'center';
    var elementStyle = {
      justifyContent: styleParams.galleryVerticalAlign,
      alignItems: styleParams.galleryHorizontalAlign,
      textAlign: styleParams.galleryTextAlign
    };
    var textPlacementRightOrLeft = GALLERY_CONSTS.hasHorizontalPlacement(styleParams.titlePlacement); // Set the texts fixed height considering the height of the love and share buttons which is about 100px;

    if (textsDisplayOnHover && this.allowAnyAction() && (styleParams.allowTitle || styleParams.allowDescription)) {
      elementStyle.paddingBottom = 70;
    }

    if (isCentered) {
      elementStyle.marginTop = style.height / 15;
    }

    if (styleParams.isRTL) {
      elementStyle.direction = 'rtl';
    } else {
      elementStyle.direction = 'ltr';
    }

    if (textPlacementRightOrLeft) {
      elementStyle.height = '100%';
    }

    return elementStyle;
  };

  _proto.getItemTexts = function getItemTexts() {
    var _this2 = this;

    var _this$props3 = this.props,
        title = _this$props3.title,
        description = _this$props3.description,
        id = _this$props3.id,
        styleParams = _this$props3.styleParams,
        style = _this$props3.style,
        isNarrow = _this$props3.isNarrow,
        shouldShowButton = _this$props3.shouldShowButton,
        container = _this$props3.container;
    var shouldShowTitle = title && styleParams.allowTitle;
    var shouldShowDescription = description && styleParams.allowDescription;
    var isNewMobileSettings = true; // TODO: featureManager.supports.mobileSettings;

    var titleSpanStyle = {};
    var descSpanStyle = {};
    var titleStyle, descStyle;

    if (shouldShowDescription) {
      titleStyle = {
        marginBottom: styleParams.titleDescriptionSpace
      };
    } else if (shouldShowButton) {
      titleStyle = {
        marginBottom: designConsts.spaceBetweenElements
      };
    } else {
      titleStyle = {
        marginBottom: 0
      };
    }

    if (shouldShowButton) {
      descStyle = {
        marginBottom: designConsts.spaceBetweenElements
      };
    } else {
      descStyle = {
        marginBottom: 0
      };
    }

    if (this.props.isMobile && isNewMobileSettings) {
      // override desktop color and fonts
      if (styleParams.isSlideshowFont) {
        if (typeof styleParams.itemFontSlideshow !== 'undefined') {
          titleStyle.font = styleParams.itemFontSlideshow.value;
          titleStyle.textDecoration = styleParams.textDecorationTitle;
        }

        if (typeof styleParams.itemDescriptionFontSlideshow !== 'undefined') {
          descStyle.font = styleParams.itemDescriptionFontSlideshow.value;
          descStyle.textDecoration = styleParams.textDecorationDesc;
        }

        if (typeof styleParams.itemFontColorSlideshow !== 'undefined') {
          titleStyle.color = styleParams.itemFontColorSlideshow.value;
          titleStyle.textDecorationColor = styleParams.itemFontColorSlideshow.value;
        }

        if (typeof styleParams.itemDescriptionFontColorSlideshow !== 'undefined') {
          descStyle.color = styleParams.itemDescriptionFontColorSlideshow.value;
          descStyle.textDecorationColor = styleParams.itemDescriptionFontColorSlideshow.value;
        }
      } else {
        if (typeof styleParams.itemFont !== 'undefined') {
          titleStyle.font = styleParams.itemFont.value;
          titleStyle.textDecoration = styleParams.textDecorationTitle;
        }

        if (typeof styleParams.itemDescriptionFont !== 'undefined') {
          descStyle.font = styleParams.itemDescriptionFont.value;
          descStyle.textDecoration = styleParams.textDecorationDesc;
        }

        if (typeof styleParams.itemFontColor !== 'undefined') {
          titleStyle.color = styleParams.itemFontColor.value;
          titleStyle.textDecorationColor = styleParams.itemFontColor.value;
        }

        if (typeof styleParams.itemDescriptionFontColor !== 'undefined') {
          descStyle.color = styleParams.itemDescriptionFontColor.value;
          descStyle.textDecorationColor = styleParams.itemDescriptionFontColor.value;
        }
      }
    }

    if (styleParams.isSlideshow && container && container.galleryWidth && container.galleryWidth < 800) {
      var maxWidth = container.galleryWidth;

      if (styleParams.allowSlideshowCounter) {
        maxWidth -= 30;
      }

      if (styleParams.playButtonForAutoSlideShow) {
        maxWidth -= 30;
      }

      titleStyle.maxWidth = maxWidth;
      descStyle.maxWidth = maxWidth;
    }

    var titleElem = shouldShowTitle && /*#__PURE__*/React.createElement(Title, {
      key: 'item-title-' + id,
      title: title,
      style: titleStyle,
      spanStyle: titleSpanStyle
    });
    var descriptionElem = shouldShowDescription && /*#__PURE__*/React.createElement(Description, {
      key: 'item-description-' + id,
      description: description,
      style: descStyle,
      spanStyle: descSpanStyle
    });
    var buttonElem = shouldShowButton && /*#__PURE__*/React.createElement(CustomButton, {
      type: "button",
      styleParams: styleParams,
      style: style,
      small: isNarrow,
      actions: {
        eventsListener: this.props.actions.eventsListener
      }
    });
    var shouldHideElement = !titleElem && !descriptionElem && !buttonElem;

    if (shouldHideElement) {
      return null;
    }

    var elementStyle = this.getElementStyle();
    var classNames = this.getElementClassNames();
    return /*#__PURE__*/React.createElement("div", {
      style: elementStyle,
      ref: function ref(x) {
        return _this2.container = x;
      },
      className: classNames,
      dir: "auto"
    }, titleElem, descriptionElem, buttonElem);
  };

  _proto.tryFixLineHeight = function tryFixLineHeight() {
    try {
      lineHeightFixer.fix(this.props, this.container);
    } catch (e) {
      if (utils.isVerbose()) {
        console.error('Error on componentDidUpdate', e);
      }
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (lineHeightFixer.shouldFix(prevProps, this.props)) {
      this.debouncedTryFixLineHeight();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this3 = this;

    this.tryFixLineHeight();
    setTimeout(function () {
      _this3.tryFixLineHeight(); // waiting for wix inline styles to take affect

    }, 1000);
  };

  _proto.render = function render() {
    return this.getItemTexts();
  };

  return Texts;
}(React.Component);

export { Texts as default };